<forge-autocomplete #autocomplete observe-scroll [allowUnmatched]="propertyMetadata.FreeEntry" [filterFocusFirst]="!propertyMetadata.FreeEntry" debounce="250"
  (forge-autocomplete-change)="onSelectedItemChange($event)" (forge-autocomplete-scrolled-bottom)="loadMore($event)" [filterOnFocus]="filterOnFocus">
  <forge-text-field [invalid]="isInvalid" data-lpignore="true" float-label-type="" [attr.shape]="forCellEdit ? 'squared' : null"
    [ngClass]="{'dense-input': dense || compact, 'cell-edit': forCellEdit}" [density]="Density"
    [required]="isRequired" [attr.label-position]="LabelPosition" show-clear popover-icon>
    <label for="{{controlId}}">{{Label}}</label>
    <input #input type="text" [disabled]="isViewOnly" [name]="Name" [required]="isRequired" [maxlength]="MaxLength"
      id="{{controlId}}" [(ngModel)]="valueModel" [attr.value-is-set]="valueModel ? '' : null" [pattern]="Regex" (input)="onSearchTextChanged($event)"
      (change)="onChange()" (focus)="onFocus()" (blur)="onBlur()" focusOnLoad [propertyMetadata]="propertyMetadata" [forCellEdit]="forCellEdit"
      (keydown)="enforceFormat($event)" data-lpignore="true" attr.telemetry="Edit-{{Label}}" tabindex="0">
      @if (allowClear) {
        <forge-icon-button tabindex="-1" (click)="clear()" slot="clear-button" dense density="small" aria-label="clear text">
          <forge-icon name="close" style="--forge-icon-color: var(--forge-theme-text-high);"></forge-icon>
          <forge-tooltip>Clear</forge-tooltip>
        </forge-icon-button>
      }
      @if (allowDetail) {
        <forge-icon-button (click)="viewDetail()" slot="end" dense density="small" aria-label="view detail"
          attr.telemetry="TypeaheadDetail-{{Label}}" (keydown)="handleIconButtonKeyDown($event)">
          <forge-icon name="search" style="--forge-icon-color: var(--forge-theme-text-high);"></forge-icon>
          <forge-tooltip>View</forge-tooltip>
        </forge-icon-button>
      }
      @if (hasHint && !isInvalid && !forCellEdit && !dense && !compact) {
        <span slot="helper-text">{{Hint}}</span>
      }
      @if (isInvalid && !dense && !compact) {
        <span slot="helper-text" class="error-red">{{error}}</span>
      }
      @if (showSpinner) {
        <forge-circular-progress slot="end" class="metadata-input--spinner" slot="end">
        </forge-circular-progress>
      }
    </forge-text-field>
  </forge-autocomplete>
